import { getReviewProjection } from "@/lib/api/review";
import type { ReviewProjection } from "@/lib/api/projection-types";
import { createProjectionStore } from "./createProjectionStore";

export const useReviewProjectionStore = createProjectionStore<ReviewProjection, []>(
  getReviewProjection,
  []
);
